module.exports = __webpack_public_path__ + "static/img/bg_about_d.cb7a1973.png";